import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { getApiError } from '@/types/apiError';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateLabelQueries, labelClearedUpdater, optimisticallyUpdateAssetLabel } from './optimisticLabelUpdate';

export const useUnassignLabel = (assetId: string) => {
  const queryClient = useQueryClient();
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  const { mutate, isPending, error } = useMutation({
    mutationFn: (taxonomyId: string) => api.taxonomy.unassignLabel(tenantId, assetId, taxonomyId),
    onMutate: () => {
      optimisticallyUpdateAssetLabel({ queryClient, assetId, tenantId, updater: labelClearedUpdater });
    },
    onSuccess: () => invalidateLabelQueries({ queryClient, assetId, tenantId }),
  });

  return {
    unassignLabel: mutate,
    isUnassigning: isPending,
    unassignError: getApiError(error),
  };
};
